module.exports = __webpack_public_path__ + "img/couples_03_V.acef7f91.webp";